import { PRESENTATION_VIDEO_URL } from "../data/content";

const extractYoutubeId = (url) => {
  const m = String(url).match(
    /(?:youtube\.com\/(?:watch\?[^"]*v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/
  );
  return m ? m[1] : null;
};

export const PresentationVideo = () => {
  const id = PRESENTATION_VIDEO_URL ? extractYoutubeId(PRESENTATION_VIDEO_URL) : null;
  if (!id) return null;

  return (
    <div
      data-testid="presentation-video"
      className="mx-auto mt-6 w-full max-w-[280px] overflow-hidden rounded-2xl border border-gold-border shadow-[0_20px_60px_rgba(197,160,89,0.12)]"
    >
      <div className="relative aspect-[9/16] w-full">
        <iframe
          src={`https://www.youtube.com/embed/${id}?rel=0`}
          title="Apresentação — Miss Aura Nº 1"
          className="absolute inset-0 h-full w-full"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};
